import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { PanelGroup, Panel } from 'react-bootstrap';

const maxNumberOfQuestions = 50;

export class FaqContent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            arrows: new Array(maxNumberOfQuestions).fill(false)
        };
    }

    handleOnClick(number) {
        const newArrows = new Array(maxNumberOfQuestions).fill(false);
        newArrows[number] = !this.state.arrows[number];
        this.setState({
            arrows: newArrows
        });
    }

    renderArrowIcon(contentType, number) {
        const {t} = this.props;
        let arrowClassName = 'fa fa-caret-down faq-caret faq-content-caret';
        if (this.state.arrows[number]) {
            arrowClassName = 'fa fa-caret-up faq-caret faq-content-caret';
        }
        return (
            <div className="contentTitle">
                <i className={arrowClassName} /> {t(`faq.${contentType}.question${number}`)}
            </div>
        );
    }
    renderQuestionAnswer(contentType, number) {
        const {t} = this.props;
        return (
            <Panel bsClass="panel panel-default-content" header={this.renderArrowIcon(contentType, number)} eventKey={`${number}`} onSelect={() => { this.handleOnClick(number); }}>
                <p>{t(`faq.${contentType}.answer${number}`)}</p>
            </Panel>
        );
    }

    getOrganizerTopQuestions() {
        const {t} = this.props;
        const topQuestions = [];
        for (let index = 0; index < 8; index ++) {
            topQuestions.push(this.renderQuestionAnswer('organizer.topQuestions', index));
        }
        return (
            <div>
                <div className="faq__heading">{t('faq.organizer.topQuestions.heading')}</div>
                <PanelGroup accordion>
                    {topQuestions}
                </PanelGroup>
            </div>
        );
    }
    getAttendeeTopQuestions() {
        const {t} = this.props;
        const topQuestions = [];
        for (let index = 0; index < 2; index ++) {
            topQuestions.push(this.renderQuestionAnswer('attendee.topQuestions', index));
        }
        return (
            <div>
                <div className="faq__heading">{t('faq.attendee.topQuestions.heading')}</div>
                <PanelGroup accordion>
                    {topQuestions}
                    <Panel bsClass="panel panel-default-content" header={this.renderArrowIcon('attendee.topQuestions', 2)} eventKey="2" onSelect={() => { this.handleOnClick(2); }}>
                        <p>{t('faq.attendee.topQuestions.answer2')} <a href="mailto:y4sd0vza@incoming.intercom-mail.com"> email us here</a>.</p>
                    </Panel>
                </PanelGroup>
            </div>
        );
    }

    getBuildChannel() {
        const {t} = this.props;
        const buildChannel = [];
        for (let index = 0; index < 16; index++) {
            buildChannel.push(this.renderQuestionAnswer('organizer.buildChannel', index));
        }
        return (
            <div>
                <div className="faq__heading">{t('faq.organizer.buildChannel.heading')}</div>
                <PanelGroup accordion>
                    {buildChannel}
                </PanelGroup>
            </div>);
    }

    getPromoteChannel() {
        const {t} = this.props;
        const promoteChannel = [];
        for (let index = 0; index < 7; index++) {
            promoteChannel.push(this.renderQuestionAnswer('organizer.promoteChannel', index));
        }
        return (
            <div>
                <div className="faq__heading">{t('faq.organizer.promoteChannel.heading')}</div>
                <PanelGroup accordion>
                    {promoteChannel}
                </PanelGroup>
            </div>);
    }

    getWorkWithRecordings() {
        const {t} = this.props;
        const workRecordings = [];
        for (let index = 0; index < 7; index++) {
            workRecordings.push(this.renderQuestionAnswer('organizer.workWithRecordings', index));
        }
        return (
            <div>
                <div className="faq__heading">{t('faq.organizer.workWithRecordings.heading')}</div>
                <PanelGroup accordion>
                    {workRecordings}
                </PanelGroup>
            </div>);
    }

    render() {
        return (
            <div>
                {this.props.faqContent === 'organizerTopQuestions' ? this.getOrganizerTopQuestions() : null}
                {this.props.faqContent === 'attendeeTopQuestions' ? this.getAttendeeTopQuestions() : null}
                {this.props.faqContent === 'buildChannel' ? this.getBuildChannel() : null}
                {this.props.faqContent === 'promoteChannel' ? this.getPromoteChannel() : null}
                {this.props.faqContent === 'workWithRecordings' ? this.getWorkWithRecordings() : null}
            </div>
        );
    }
}
FaqContent.propTypes = {
    t: PropTypes.func,
    faqContent: PropTypes.string
};

export default(translate(['translation'])(FaqContent));



// WEBPACK FOOTER //
// ./src/components/faq-page/faqContent.js